import { LocalStorageService } from "@/shared/services";
import { USER_KEY } from "@/shared/utilities/constants";

const getStages = () => LocalStorageService.get(USER_KEY)?.stages;

const routes = {
  path: "/Poetry",
  component: () => import("@/shared/views/ModuleOutlet.vue"),
  children: [
    {
      path: "",
      name: "PoetryHome",
      component: () => import("../views/PoetryHomeView.vue"),
      beforeEnter(to, from, next) {
        const role = getStages().verseAlGhrameyh.read;
        if (role && to.name == "PoetryHome") {
          next();
        } else {
          next({ name: "Home" });
        }
      },
    },
    {
      path: ":id",
      name: "Poetry",
      component: () => import("../views/PoetryView.vue"),
      beforeEnter(to, from, next) {
        const role = getStages().verseAlGhrameyh.read;
        if (role && to.name == "Poetry") {
          next();
        } else {
          next({ name: "Home" });
        }
      },
    },
  ],
};

export default routes;
